// serviceWorkerRegistration.js — registers public/service-worker.js in production builds only.
// Registration failures are swallowed on purpose: this is a progressive enhancement
// (faster repeat loads, installable app shell) and must never block or break the
// app if the browser doesn't support it or the file 404s for any reason.

export function register() {
  if (process.env.NODE_ENV !== 'production') return;
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js').catch(() => {
      // Non-fatal — app works fine online-only without it.
    });
  });
}
